(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.pmsInit === 'true') return;
    section.dataset.pmsInit = 'true';

    var swatches = section.querySelectorAll('.pms__swatch');
    var mediaItems = section.querySelectorAll('.pms__media-item');
    var contentItems = section.querySelectorAll('.pms__content-item[data-content-for]');
    if (!swatches.length) return;

    function activate(targetId) {
      swatches.forEach(function (btn) {
        var isActive = btn.getAttribute('data-swatch-target') === targetId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      mediaItems.forEach(function (item) {
        var isActive = item.getAttribute('data-media-for') === targetId;
        item.classList.toggle('is-active', isActive);
      });

      contentItems.forEach(function (item) {
        var isActive = item.getAttribute('data-content-for') === targetId;
        item.classList.toggle('is-active', isActive);
      });
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-swatch-target'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.purchase-motion-showcase').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.purchase-motion-showcase');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var swatch = event.target.closest('.pms__swatch');
    if (swatch) swatch.click();
  });
})();
